@if(!isSuperAdminScreen()) {
  <div class="layout-topbar flex">
    <div class="topbar-start col p-0">
      <button #menubutton type="button" class="topbar-menubutton  p-trigger" (click)="onMenuButtonClick()">
        <i class="pi pi-bars"></i>
      </button>

      <!-- <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb> -->
      <span class="font-semibold text-xl text-primary lg:ml-20 lg:pl-6" style="cursor: default;">Administration Center</span>

      <div class="hidden md:inline-flex w-80 lg:w-105 items-center gap-1 ml-6">
        @if (headerComputed()) {
          <div class="pathfinder-header">{{headerComputed()}}</div>   
          @if (headerComputed().length>65) {
            <p-popover #fullName>
              <ng-container>
                  {{headerComputed()}}
              </ng-container>
            </p-popover>
            <i class="ml-2 fa-light fa-ellipsis cursor-pointer text-primary" [pTooltip]="headerComputed()" [showDelay]="500" (click)="fullName.toggle($event)"></i>
          }
          @if (isNonLiveEnvironmentComputed()) {
            <p-popover #infoMsg>
              <ng-container>
                  {{nonLiveEnvironmentComputed()}}
              </ng-container>
            </p-popover>
            <i class="ml-2 fa-light fa-circle-info cursor-pointer" [pTooltip]="nonLiveEnvironmentComputed()" [showDelay]="500" (click)="infoMsg.toggle($event)"></i>
          }
        }
      </div>
    </div>

    <div class="topbar-end flex col p-0 justify-end">
      <ul class="topbar-menu flex justify-center gap-4">
        @if(authService.userPrincipalComputedSignal() &&
          !authService.authUserComputedSignal()?.appMetadata?.isFirstTimeLogin) {
          <li>
            <lib-notification-feature-bell></lib-notification-feature-bell>
          </li>
        }

        @if(authService.userPrincipalComputedSignal() && 
          authService.userPrincipalComputedSignal()!.accessibleTenants.length > 1 &&
          !authService.isUnauthorizedComputedSignal() &&
          !environmentService.isAdministrationCenter) {
          <li>
            <p-button icon="fa-duotone fa-solid fa-repeat fa-lg" [rounded]="true" [text]="true" severity="secondary"
            pTooltip="Switch Tenant" [showDelay]="500" tooltipPosition="left" class="shrink-0" (click)="onSelectTenantButtonClick()"></p-button>
          </li>
        }
        @if(authService.isAuthenticatedComputedSignal() && authService.isCodyAdministratorComputedSignal()) {
          <li>
            <p-button [rounded]="true" [text]="true" pTooltip="Super Admin" [showDelay]="500"
              icon="fa-duotone fa-solid fa-crown fa-lg"
              tooltipPosition="left" class="shrink-0" severity="secondary"
              (click)="onSuperAdminButtonClick()">
            </p-button>
          </li>
        }
        <li>
          @if (avatarImageUrl; as url) {
            <p-avatar
              class="cursor-pointer avatar-cover"
              (click)="onProfileButtonClick()"
              [image]="url"
              [pTooltip]="currentUserDetails?.given_name + ' ' + currentUserDetails?.family_name"
              tooltipPosition="left"
              styleClass="text-white text-sm"
              [style]="{ 'margin-bottom': '2px' }"
              shape="circle"
              size="normal">
            </p-avatar>
          } @else {
            <p-avatar
              class="cursor-pointer"
              (click)="onProfileButtonClick()"
              [label]="currentUserDetails?.given_name?.split('')?.[0] + '' + currentUserDetails?.family_name?.split('')?.[0]"
              [pTooltip]="currentUserDetails?.given_name + ' ' + currentUserDetails?.family_name"
              tooltipPosition="left"
              styleClass="text-white bg-slate-500 text-sm"
              [style]="{ 'margin-bottom': '2px' }"
              shape="circle"
              size="normal">
            </p-avatar>
          }
        </li>
      </ul>
    </div>
  </div>
}
@else if (isSuperAdminScreen()) {
  <div class="layout-topbar flex">
    <div class="topbar-start ml-8 flex">
      <button #menubutton type="button" class="topbar-menubutton  p-trigger" (click)="onMenuButtonClick()">
        <i class="pi pi-bars"></i>
      </button>
      <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
      <span class="font-semibold text-xl text-primary lg:ml-20" style="cursor: default;">Super Admin</span>
    </div>
    
    <div class="flex justify-end items-center gap-6">
      <lib-notification-feature-bell></lib-notification-feature-bell>
      <p-button icon="fa-solid fa-door-open" (onClick)="onBackToAdministrationCenterButtonClick()" [text]="true" [rounded]="true"
        severity="secondary" pTooltip="Back To Administration Center" tooltipPosition="left">
      </p-button>
      <p-button icon="fa-solid fa-arrow-right-from-bracket" (onClick)="logout()" [text]="true" [rounded]="true"
        severity="danger" pTooltip="Log Out" tooltipPosition="left">
      </p-button>
    </div>
  </div>
}